import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HerissonLogo from "@/components/HerissonLogo";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { adminLogin } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("festival@herisson-sous-gazon.ch");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(email.trim().toLowerCase(), password);
      toast.success("Connecté en tant qu'admin");
      nav("/admin");
    } catch (e) { toast.error(e?.response?.data?.detail || "Échec de connexion admin"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0b] text-neutral-100 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md card-hsg p-8">
        <div className="flex flex-col items-center">
          <HerissonLogo size="lg" />
          <p className="text-neutral-400 mt-4">Connexion admin</p>
        </div>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-neutral-500">Email</span>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2" data-testid="admin-email" />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-neutral-500">Mot de passe</span>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full bg-neutral-900 border border-neutral-700 rounded-lg px-3 py-2" data-testid="admin-password" />
          </label>
          <button disabled={loading} type="submit" className="brand-gradient-btn w-full py-3 rounded-xl" data-testid="admin-login-submit">
            {loading ? "…" : "Se connecter"}
          </button>
        </form>
        <p className="text-xs text-neutral-500 mt-4">POST /api/admin/login — JWT bearer stocké en localStorage</p>
      </div>
    </div>
  );
}
